
import React, { useState, useRef } from 'react';
import JoditEditor from 'jodit-react';
import { FastField } from 'formik';
import { Typography } from '@mui/material';


// "TextEditor" can be used with or without formik
export const TextEditor = ({textContent, placeholder, getContentForForm, imgExtensions, docExtensions }) => {
	const editor = useRef(null);
	const [content, setContent] = useState(textContent || '');

    const imgExt = imgExtensions || ['jpg', 'png', 'jpeg', 'gif', 'svg', 'webp',]
    const docExt = docExtensions || ['pdf','txt','csv','xml','html','doc','docx','rtf','xls','xlsx','ppt','pptx',]
    const fileExtensions = imgExt.concat(docExt)
    
	const config = {
        readonly: false, // all options from https://xdsoft.net/jodit/doc/,
        placeholder: placeholder || 'Ecrivez ici...',
        theme: 'default',
        language: 'fr',
        disablePlugins: ["about","spellcheck","speech-recognize","powered-by-jodit", "class-span"],
        removeButtons: ["selectall"],
        minHeight: 500,
        minWidth: 100,
        maxWidth: '100%',
        uploader: {
            insertImageAsBase64URI: true,
            imagesExtensions: fileExtensions,
            
            defaultHandlerSuccess: function (data, resp) {
                const fileField = 'files';
                if (!data[fileField] || !data[fileField].length) return;

                for (let i = 0; i < data[fileField].length; i += 1) {
                    const base64Image = data.baseurl + data[fileField][i];
                    const imageData = base64Image.split(';');
                    const contentType = imageData[0];
                    const fileExt = contentType.split('/')[1];
                    const contentImg = imageData[1].split(',')[1];
                    
                    if (imgExt.includes(fileExt)) {
                        this.s.insertImage(base64Image);
                    } else {
                        const fileName = contentImg.slice(0, 10);
                        const linkText = [fileName, fileExt].join('.');
                        this.s.insertHTML(`<a href='${base64Image}'>${linkText}</a>`);
                    }
                }
            },
        },
	};

	return (
		<JoditEditor
			ref={editor}
			value={content || textContent}
			config={config}
			tabIndex={1} // tabIndex of textarea
			onBlur={newContent => typeof getContentForForm === 'function' ? getContentForForm(newContent) : setContent(newContent)} // preferred to use only this option to update the content for performance reasons
			// onChange={newContent => {}}
		/>
	);
};



const TextEditorInput = ({name, label='', required=true, placeholder, imgExtensions, docExtensions}) => {
    return (
        <FastField name={name}>
            {({field, meta, form}) => {
                const isInValid = meta?.error && meta?.touched;

                const getContentForForm = (textEditorContent) => {

                    if(!textEditorContent || textEditorContent === '<p><br></p>') {
                        form.setFieldTouched(name, 'champ requis');
                        form.setFieldError(name, true);
                        return false;
                    }
                    form.setFieldValue(name, textEditorContent);
                }


                return (
                    <>
                        <div>
                            <Typography variant='caption' color={isInValid && 'error'}> {isInValid ? meta?.error : label} {required && label && '*'}</Typography>
                        </div>
                        <TextEditor {...{textContent: field.value, name, placeholder, getContentForForm, imgExtensions, docExtensions}}/>
                    </>
                );
            }}
        </FastField>
    );
}

export default TextEditorInput;